import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";

const confirmDialogState = atom({
  key: "confirmDialogState",
  default: false,
});
const confirmDialogMessageState = atom({
  key: "confirmDialogMessageState",
  default: "",
});

const useConfirmDialog = () => {
  const [confirmDialog, setConfirmDialog] = useRecoilState(confirmDialogState);
  const [confirmDialogMessage, setConfirmDialogMessage] = useRecoilState(
    confirmDialogMessageState
  );
  return {
    confirmDialog,
    setConfirmDialog,
    confirmDialogMessage,
    setConfirmDialogMessage,
  };
};

const useConfirmDialogValue = () => useRecoilValue(confirmDialogState);
const useSetConfirmDialog = () => useSetRecoilState(confirmDialogState);
const useConfirmDialogState = () => useRecoilState(confirmDialogState);
const useConfirmDialogMessageValue = () =>
  useRecoilValue(confirmDialogMessageState);
const useSetConfirmDialogMessage = () =>
  useSetRecoilState(confirmDialogMessageState);
const useConfirmDialogMessageState = () =>
  useRecoilState(confirmDialogMessageState);

export {
  useConfirmDialog,
  useConfirmDialogState,
  useSetConfirmDialog,
  useConfirmDialogValue,
  useConfirmDialogMessageValue,
  useSetConfirmDialogMessage,
  useConfirmDialogMessageState,
};
